import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '@api/notificaciones';
import type { FiltrosNotif } from '@api/notificaciones';
import { apiClient } from '@api/client';
import type { ApiResponse } from '@/types';

const KEY = 'notificaciones';

export const useNotificaciones = (f: FiltrosNotif) =>
  useQuery({ queryKey: [KEY, f], queryFn: () => api.fetchNotificaciones(f), staleTime: 15_000 });

export const useNotifCount = () =>
  useQuery({ queryKey: [KEY, 'count'], queryFn: api.fetchCount, staleTime: 30_000, refetchInterval: 30_000 });

const inv = (qc: ReturnType<typeof useQueryClient>) => ({
  onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
});

export const useMarcarLeida = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (id: number) => api.marcarLeida(id), ...inv(qc) });
};

export const useMarcarTodasLeidas = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: api.marcarTodasLeidas, ...inv(qc) });
};

export const useArchivar = () => {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (ids: number[]) => api.archivarNotificaciones(ids), ...inv(qc) });
};

// ─── Preferencias ─────────────────────────────────────────────
export const usePreferencias = () =>
  useQuery({
    queryKey: [KEY, 'preferencias'],
    queryFn: () => apiClient.get<ApiResponse<unknown[]>>('/notificaciones/preferencias').then(r => r.data.data),
    staleTime: 60_000,
  });

export const useGuardarPreferencias = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (prefs: unknown) =>
      apiClient.put('/notificaciones/preferencias', { preferencias: prefs }).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY, 'preferencias'] }),
  });
};
